export function getDecimalLength(num) {
    if (Math.floor(num.valueOf()) === num.valueOf()) {
        return 0;
    }
    return num.toString().split('.')[1].length || 0;
}

export function getNaturalNumberLength(num) {
    return Math.floor(num).toString().length;
}

export function getNumberWithDecimalAsString(num, fractionDigits = 0) {
    return (Math.round(num * 100) / 100).toFixed(fractionDigits).toString();
}
